<!--
 * @Author: your name
 * @Date: 2022-05-30 15
-->
<template>
  <div class="serve">
    <div class="banner">
			<img class="bannerImgText" :class="{'act-showee':actShow}" src="~@/assets/img/serve/service-text.png" alt="" />
      <img class="bannerImg" src="https://voge-resource.vogemotor.com/service-bg.jpg" alt="">
    </div>
    <!-- 导航 -->
    <div class="conter">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item,idx) in baseTabs.list" :key="idx">
          <second-title
            :englithTitle="item.englithTitle"
            :englithA="item.englithA"
            :changname="item.changname"
            :addone="item.addone"
            :addtow="item.addtow"
          ></second-title>
        </el-tab-pane>
      </el-tabs>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import SecondTitle from '@/components/SecondTitle'
export default {
  components:{
    SecondTitle,
  },
  data(){
    return{
      actShow:false,
      activeName: "trends",
      baseTabs:{
        list:[
        {
          id:0,
          label: "保修范围",
          name: "trends",
          englithTitle: "arranty coverage",
          englithA:"W",
          changname:"保修范围",
          addone:"无极服务",
          addtow:"保修范围",
          path:'/warranty-coverage'
        },
        {
          id:1,
          label: "服务反馈",
          name: "activity",
          englithTitle: "ervice feedback",
          englithA:"S",
          changname:"服务反馈",
          addone:"无极服务",
          addtow:"服务反馈",
          path:'/feedback'
        },
        {
          id:2,
          label: "保养指南",
          name: "appraisal",
          englithTitle: "aintenance guide",
          englithA:"M",
          changname:"保养指南",
          addone:"无极服务",
          addtow:"保养指南",
          path:'/maintain'
        },
        {
          id:3,
          label: "摩旅服务",
          name: "serve",
          englithTitle: "oge Events",
          englithA:"V",
          changname:"摩旅服务",
          addone:"无极服务",
          addtow:"摩旅服务",
          path:'/travel-service'
        },
      ]
      }
    }
  },
  created(){
    if (this.$route.path == "/serve") {
      this.$router.push('/warranty-coverage')
    }
    setTimeout(() => {
			this.actShow = true
		}, 500);
  },
  methods:{
    handleClick(tab, event){
      this.baseTabs.list.forEach((item,idx) => {
        if (tab.index == item.id) {
          this.$router.push(item.path)
        }
      });
    }
  },
}
</script>
<style lang="scss">
.serve{
  // max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  .banner {
    width: 100%;
    height: 650px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .bannerImgText{
        position:absolute;
        opacity: 0;
        transition: 1.5s;
        bottom: 20px;

    }
    .act-showee{
        opacity: 1;
        bottom: 30%;
    }
    .bannerImg {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
  }
  .conter{
    background: url('../../assets/img/serve/serveBgm.jpg') no-repeat center;
    background-size: cover;
    .el-tabs__nav-wrap::after{
      height: 0px;
    }
    .el-tabs__nav-scroll {
      background-color:#EEC20A ;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-tabs__nav{
        display: flex;
        justify-content: space-between;
        width: 820px;
        .el-tabs__active-bar {
          height: 0px;
        }
        .el-tabs__item{
          padding: 0 20px;
          font-size: 16px;
          color: rgb(255, 255, 255);
        }
        .el-tabs__item.is-active{
          color: #000;
          font-weight: 800;
        }
        .el-tabs__item:hover{
          color: #000;
          font-weight: 800;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/serve/serve.vue